import DOMPurify from 'dompurify'

// Replace cid: protocol URLs (email-embedded images) with transparent pixel
// Prevents CSP violations for historical tickets with unconverted inline images
const TRANSPARENT_PIXEL = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

// Dangerous CSS patterns that enable XSS — stripped from style attributes
const DANGEROUS_CSS = /expression\s*\(|url\s*\(|behavior\s*:|javascript\s*:|-moz-binding\s*:|@import/gi

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  // Replace unresolved cid: image refs with transparent pixel
  if (node.tagName === 'IMG' && node.getAttribute('src')?.startsWith('cid:')) {
    node.setAttribute('src', TRANSPARENT_PIXEL)
    node.setAttribute('alt', '[embedded image]')
  }

  // Sanitize style attributes — keep safe layout CSS, strip XSS vectors
  if (node.hasAttribute('style')) {
    const style = node.getAttribute('style') || ''
    if (DANGEROUS_CSS.test(style)) {
      DANGEROUS_CSS.lastIndex = 0
      node.setAttribute('style', style.replace(DANGEROUS_CSS, ''))
    }
    DANGEROUS_CSS.lastIndex = 0
  }
})

export function useSanitize() {
  const sanitize = (html: string | null | undefined): string => {
    if (!html) return ''
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: [
        'p', 'br', 'b', 'i', 'u', 's', 'em', 'strong', 'a', 'ul', 'ol', 'li',
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'blockquote', 'pre', 'code',
        'span', 'div', 'img', 'table', 'thead', 'tbody', 'tr', 'th', 'td',
        'hr', 'sub', 'sup',
      ],
      ALLOWED_ATTR: [
        'href', 'target', 'rel', 'src', 'alt', 'title', 'width', 'height',
        'class', 'colspan', 'rowspan', 'style',
      ],
      ALLOW_DATA_ATTR: false,
    })
  }

  return { sanitize }
}
